// passive events
(window as any)['__zone_symbol__PASSIVE_EVENTS'] = ['scroll', 'touch', 'touchstart', 'mousewheel', 'wheel'];
